module.exports = __webpack_public_path__ + "img/Zen1.7edd5d0b.webp";